import Icon from '../../components/Icon.vue'

Icon.register({"regular/file-alt":{"width":384,"height":512,"paths":[{"d":"M288 248V276C288 282.6 282.6 288 276 288H108C101.4 288 96 282.6 96 276V248C96 241.4 101.4 236 108 236H276C282.6 236 288 241.4 288 248zM276 320H108C101.4 320 96 325.4 96 332V360C96 366.6 101.4 372 108 372H276C282.6 372 288 366.6 288 360V332C288 325.4 282.6 320 276 320zM384 131.9V464C384 490.5 362.5 512 336 512H48C21.5 512 0 490.5 0 464V48C0 21.5 21.5 0 48 0H252.1C264.8 0 277 5.1 286 14.1L369.9 98C378.9 106.9 384 119.2 384 131.9zM256 51.9V128H332.1L256 51.9zM336 464V176H232C218.7 176 208 165.3 208 152V48H48V464H336z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/regular/file-alt.js
// module id = null
// module chunks = 